const buildValidLocalDate = (year, month, day) => {
  const date = new Date(year, month - 1, day);
  if (
    Number.isNaN(date.getTime())
    || date.getFullYear() !== year
    || date.getMonth() !== month - 1
    || date.getDate() !== day
  ) {
    return null;
  }
  return date;
};

export const formatLocalDateAsIso = (date) => (
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
);

export const parseBusinessDate = (value) => {
  if (value instanceof Date) {
    return new Date(value.getTime());
  }

  const rawValue = String(value || '').trim();
  if (!rawValue) {
    return new Date(Number.NaN);
  }

  const isoLikeMatch = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/);
  if (isoLikeMatch) {
    const localDate = buildValidLocalDate(
      Number(isoLikeMatch[1]),
      Number(isoLikeMatch[2]),
      Number(isoLikeMatch[3])
    );
    if (localDate) {
      return localDate;
    }
  }

  const usDateMatch = rawValue.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/);
  if (usDateMatch) {
    const month = Number(usDateMatch[1]);
    const day = Number(usDateMatch[2]);
    const year = Number(usDateMatch[3].length === 2 ? `20${usDateMatch[3]}` : usDateMatch[3]);
    const localDate = buildValidLocalDate(year, month, day);
    if (localDate) {
      return localDate;
    }
  }

  return new Date(rawValue);
};

export const toBusinessIsoDate = (value) => {
  const date = parseBusinessDate(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return formatLocalDateAsIso(date);
};

export const getTodayBusinessIsoDate = () => formatLocalDateAsIso(new Date());

export const getBusinessDayStampUtc = (value) => {
  const date = parseBusinessDate(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
};

